var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4C28.8366 4 36 11.1634 36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4ZM28.0923 13.5816C27.5191 13.0256 26.6344 13.0002 26.0329 13.493L25.8887 13.627L17.6842 22.2623L14.1322 18.3737L13.9906 18.2369C13.3988 17.7323 12.5138 17.7402 11.93 18.2847C11.3462 18.8293 11.2677 19.7201 11.7182 20.3565L11.8419 20.51L17.6401 26.8571L28.1372 15.8082L28.2638 15.6572C28.7266 15.0297 28.6654 14.1376 28.0923 13.5816Z",
    fill: "#1DAB98"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 19.5,
    r: 10.5,
    fill: "#1DAB98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2721 22.7927L7.50097 20.9789L29.9193 11.7912L14.3126 22.1051L15.3518 25.0524L15.386 23.3302L29.9193 11.7912L24.8144 26.4202L18.786 24.4444L15.2838 28.4979L13.2721 22.7927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCircleGreen);
export default __webpack_public_path__ + "static/media/send-circle-green.375ec4aaf5f66a168ec18a30457b8771.svg";
export { ForwardRef as ReactComponent };